import { withTooltip, THEMES } from "cdk-radial";

const getTooltipConfig = (tooltipId, text) => ({
  id: tooltipId,
  text,
  theme: THEMES.LIGHT,
});

export const BundleCardTitle = (props) => {
  const { name } = props;
  const bundleName = name?.trim();
  
  const compwithToolTip = (compProps) => {
    return (
      <div
        {...compProps}
        className={
          name?.length > 46
            ? "api-dir-pkg_bundle_title_3"
            : "api-dir-pkg_bundle_title_2"
        }
      >
        {bundleName}
      </div>
    );
  };
  
  const BundleNameWithTooltip = withTooltip(
    compwithToolTip,
    getTooltipConfig('tooltip-id-bundle-name', `Bundle Name: ${bundleName}`)
  );
  
  return <BundleNameWithTooltip />;
};
